import { downloadBase64Document } from "@utils/utils";

import { ExportTypeEnum, useExportDraftReportDocumentMutation } from "@api/graphql/types-and-hooks";
import { notifyError } from "@components/notifications/notifications";
import { useReport } from "@providers/ReportProvider";

export const DRAFT_EXPORT_ERROR = "Could not export the draft. Please try again.";

export const useDraftExport = () => {
  const { report } = useReport();

  const mutation = useExportDraftReportDocumentMutation({
    onSuccess: (data) => {
      const { file, fileName } = data.exportDraftReportDocument ?? {};
      if (!file) return notifyError(DRAFT_EXPORT_ERROR);
      downloadBase64Document(file, fileName ?? undefined);
    },
    onError: () => notifyError(DRAFT_EXPORT_ERROR),
  });

  return {
    isPending: mutation.isPending,
    exportDraft: (exportType: ExportTypeEnum) => mutation.mutate({ reportId: report.id, exportType }),
  };
};
